export default __webpack_public_path__ + "static/media/baseballLoadingSpinner.b1b30b6c.gif";